import { baseUrl, ServiceType } from 'src/contstant/apiEndpoints';
import { GBSAHeliosClient } from '@amzn/gbsa-helios-typescript-client';

export const apiHeliosClient = new GBSAHeliosClient({
  region: 'us-west-2',
  endpoint: baseUrl(ServiceType.HELIOS),
  requestHandler: {
    credentials: 'include',
  },
});
